import React from "react"
import { ScrollReveal } from "../ui/scroll-reveal"
import { Button } from "../ui/button"
import { Link, useLocation } from "react-router-dom"
import { EventCategory } from "../../lib/analytics"
import { safeTrackEvent } from "../../lib/analytics-utils"

export function CtaSection() {
  const location = useLocation();
  
  const handleConsultationClick = () => {
    safeTrackEvent({
      category: EventCategory.Engagement,
      label: 'engagement_success_stories_schedule_consultation',
      context: {
        sourcePage: location.pathname,
        destinationPage: '/contact',
        section: 'page_bottom'
      }
    });
  };
  
  return (
    <ScrollReveal>
      <div className="mt-20 text-center">
        <h3 className="text-2xl font-semibold mb-4">Ready to Write Your Own Success Story?</h3>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8">
          Contact us today to discuss how our structured AI consulting services can deliver immediate, 
          measurable results for your organisation.
        </p>
        <Button
          onClick={handleConsultationClick}
          asChild
          size="lg"
          className="px-8"
        >
          <Link to="/contact">
            Schedule Your Consultation
          </Link>
        </Button>
      </div>
    </ScrollReveal>
  )
} 